<template>
  <ProductBuyDetail>
    <template v-slot:icon>
      <span class="af af-delivery"></span>
    </template>
    <template v-slot:text>
      <div v-click-outside="onClickOutside">
        <div
          ref="zipFormContainer"
          class="zip-form-container"
          :class="[zipFormVisible && 'active', zipError && 'error']"
          @click.stop=""
          v-if="mounted"
        >
          <ZipForm :form-style="zipFormClass" :product="product.hashKey" @getZipSuccess="getZipSuccess" @getZipError="getZipError()" />
        </div>
        <div class="product-delivery" ref="deliveryInfo">
          <div ref="deliveryTitle" class="delivery-time-block">
            <div v-if="!loading && accurate" class="delivery-title">
              <span class="delivery-location" v-if="location.city && location.region">
                <span v-if="showFreeShipping"><a href="/delivery" class="accent">Free shipping</a> to </span><span v-else>Delivered to </span>
                <a class="delivery-region accent" @click.prevent.stop="onRegionClick">{{ location.city }}, {{ location.region }}</a>
              </span>
              <template v-if="product.isProductAvailableInGeo">
                <span class="delivery-semi-colon"> : </span>
                <span class="delivery-time">
                  <DeliveryTimeTooltip :message="etaMessage">{{ estimateMessage }}</DeliveryTimeTooltip>
                </span>
              </template>
            </div>
            <div v-else-if="!loading && error && mounted" class="delivery-title-invalid-region">
              <span>Sit tight — there’s been a technical error, but we’re working to fix it quickly. </span>
              <a class="delivery-region secondary accent" @click.prevent.stop="onRegionClick">Get delivery estimate</a>
            </div>
            <div v-else-if="!loading && !error && mounted" class="delivery-title-invalid-region">
              <a class="delivery-region secondary accent" @click.prevent.stop="onRegionClick">Get delivery estimate</a>
            </div>
            <div v-else class="product-delivery-loading skeleton">&nbsp;</div>
          </div>
        </div>
      </div>
    </template>
  </ProductBuyDetail>
</template>

<script>
import { MediaUtils, ClickOutside } from '@/pixel/index';
import ZipForm from './ZipForm.vue';
import DeliveryTimeTooltip from './DeliveryTimeTooltip.vue';
import ProductBuyDetail from '@/components/product/ProductBuyDetail.vue';
import useCommon from '@/compositions/useCommon';
import useLifecycleHook from '@/compositions/useLifecycleHook';

export default {
  name: 'ProductDelivery',
  components: {
    ZipForm,
    DeliveryTimeTooltip,
    ProductBuyDetail,
  },

  directives: {
    ClickOutside,
  },

  props: {
    loading: {},
    product: {},
    price: {},
    error: {},
    accurate: {},
    location: {},
    estimateMessage: {},
  },
  data() {
    return {
      zipFormClass: '',
      zipFormVisible: false,
      zipError: false,
      shouldIndentRow: false,
    };
  },
  setup() {
    const { shippingDiscount, showContactBanner, user, etaMessage, loadMessaging } = useCommon();
    const { mounted } = useLifecycleHook();

    return { shippingDiscount, showContactBanner, user, etaMessage, loadMessaging, mounted };
  },
  computed: {
    showFreeShipping() {
      return (
        (!this.user || !this.user.isTrade) &&
        this.showContactBanner &&
        this.shippingDiscount &&
        this.shippingDiscount.details &&
        this.price.final &&
        !!this.shippingDiscount.shippingDiscountThreshold &&
        this.price.final >= this.shippingDiscount.shippingDiscountThreshold
      );
    },
    inStock() {
      if (!this.estimate) {
        return false;
      }
      return this.estimate.productIsInStock;
    },
  },
  methods: {
    getZipSuccess(zipCode) {
      this.zipError = false;
      this.zipFormVisible = false;
      this.$emit('updateZip', zipCode);
    },
    getZipError() {
      this.zipError = true;
    },
    onRegionClick() {
      this.zipFormVisible = !this.zipFormVisible;

      if (MediaUtils.isTabletAndSmaller) {
        window.scrollTo({
          top: window.scrollY + this.$refs.deliveryInfo.getBoundingClientRect().top - 100,
          behavior: 'smooth',
        });
      }
    },
    onClickOutside() {
      this.zipError = false;
      this.zipFormVisible = false;
    },
  },
};
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';
@import '@/pixel/style/mixins';

.product-delivery {
  position: relative;
}

.product-delivery-loading {
  width: 150px;
}

.zip-form-container {
  z-index: 13;
  background: white;
  visibility: hidden;
  opacity: 0;
  transition: opacity 100ms ease-out;
  position: absolute;
  @mixin overlay;
  min-width: 200px;

  &.active {
    visibility: visible;
    opacity: 1;
    top: var(--space-6);
    transition: opacity 100ms ease-out;
  }

  &.error {
    height: 230px;
  }
}
</style>
